import { USER_ROLES } from './user'

export const USER_GROUP = {
  ALL: [
    USER_ROLES.ADMIN.value,
    USER_ROLES.INTERNAL_USER.value,
    USER_ROLES.INTERNAL_USER_LIMITED.value,
    USER_ROLES.EXTERNAL_DIRECT_CUSTOMER.value,
    USER_ROLES.EXTERNAL_RESELLER_CUSTOMER.value,
    USER_ROLES.EXTERNAL_RESELLER.value,
    USER_ROLES.EXTERNAL_USER_WHITE_LABEL.value,
  ],
  ADMIN_ONLY: [USER_ROLES.ADMIN.value],
  ADMIN_AND_CUSTOMERS: [
    USER_ROLES.ADMIN.value,
    USER_ROLES.EXTERNAL_DIRECT_CUSTOMER.value,
    USER_ROLES.EXTERNAL_RESELLER_CUSTOMER.value,
    USER_ROLES.EXTERNAL_RESELLER.value,
  ],
}

export const PAGE = {
  CUSTOMERS: {
    PATH: '/customers',
    ROLES: USER_GROUP.ALL,
  },
  USER: {
    PATH: '/user',
    ROLES: USER_GROUP.ALL,
  },
  CAMPAIGNS: {
    PATH: '/campaigns',
    ROLES: USER_GROUP.ALL,
  },
  ORDERS: {
    PATH: '/orders',
    ROLES: USER_GROUP.ALL,
  },
  ORDER: {
    PATH: '/order',
    ROLES: USER_GROUP.ALL,
  },
  JOBS: {
    PATH: '/jobs',
    // Customers see only their own jobs (resellers: own + child customers); the
    // server scopes /jobs, see server/src/controllers/jobs/jobAccess.ts.
    ROLES: USER_GROUP.ADMIN_AND_CUSTOMERS,
  },
  ORDER_PREVIEWS: {
    PATH: '/order-previews',
    ROLES: USER_GROUP.ALL,
  },
  VACANCIES: {
    PATH: '/vacancies',
    ROLES: [], // Empty array means it's public
  },
  APPLICATION: {
    PATH: '/application',
    ROLES: [], // Empty array means it's public
  },
  DASHBOARD: {
    PATH: '/dashboard',
    ROLES: USER_GROUP.ALL,
  },
  LEADS: {
    PATH: '/campaigns',
    ROLES: USER_GROUP.ALL,
  },
  LEADS_OVERVIEW: {
    PATH: '/leads-overview',
    ROLES: USER_GROUP.ALL,
  },
  LEADS_BY_ORDER: {
    PATH: '/leads-by-order/:orderId',
    ROLES: USER_GROUP.ALL,
  },
  ACCOUNTS_AND_PERMISSIONS: {
    ACCOUNTS: {
      INTERNAL: {
        PATH: '/accounts/internal',
      },
      EXTENRAL: {
        PATH: '/accounts/external',
      },
    },
    PERMISSIONS: {
      RESELLER: {
        PATH: '/permissions/reseller',
      },
      RESELLER_CUSTOMER: {
        PATH: '/permissions/reseller-customer',
      },
      DIRECT_CUSTOMER: {
        PATH: '/permissions/direct-customer',
      },
    },
    ROLES: USER_GROUP.ALL,
  },
  ANALYTICS: {
    PATH: '/analytics',
    ROLES: USER_GROUP.ALL,
  },
  PRODUCT_MANAGEMENT: {
    PATH: '/product-management',
    ROLES: USER_GROUP.ADMIN_ONLY,
  },
}
